var map = {
	"./FatCatGameStudioBackground.png": "0fba",
	"./FatcatGameStudio.png": "91a8",
	"./FatcatGameStudio2.png": "e785",
	"./GameIcon/Icon.png": "d152",
	"./GameIcon/Icon2.png": "681f",
	"./GameIcon/LazyLovers.png": "84d8",
	"./GameIcon/LogoSlothysBakery.png": "935f",
	"./GameIcon/MatchTheRunes.png": "7287",
	"./GameIcon/Mix2WordIcon.png": "ba21",
	"./GameIcon/PigYearLogo.png": "2b7f",
	"./GameIcon/PizzaMasterLogo.png": "8c04",
	"./GameIcon/SlothysLogo.png": "a2ef",
	"./MemberIcons/AldhairVeraIcon.png": "d368",
	"./MemberIcons/AldhairVeraLogo.png": "c581",
	"./PlatformIcons/appGallery.png": "7a5f",
	"./PlatformIcons/appstore.png": "e308",
	"./PlatformIcons/itch-io.png": "0893",
	"./PlatformIcons/itch-io.svg": "f031",
	"./PlatformIcons/playstore.png": "2e70",
	"./css/main.css": "5aea",
	"./icons/facebook.svg": "8485",
	"./icons/github.svg": "14f6",
	"./icons/google-plus.svg": "2cce",
	"./icons/instagram.svg": "bd6c",
	"./icons/linkedin.svg": "9ed9",
	"./icons/parcel.svg": "9582",
	"./icons/twitter.svg": "acf9",
	"./icons/whatsapp.svg": "7583",
	"./icons/youtube.svg": "11ef",
	"./pdf-privacy/Lazy Love Privacy Policy.pdf": "7c19",
	"./pdf-privacy/Memorama_ Match the Runes by FatCat Game Studio _ Privacy policy.pdf": "a236",
	"./pdf-privacy/Pig Year_ Food Fight by Inart Game Studio- Privacy policy.pdf": "4ff3",
	"./pdf-privacy/Política de privacidad de Memorama_ Match the Runes.pdf": "37e4",
	"./pdf-privacy/Política de privacidad de Memorama_ Match the Runes_Old.pdf": "0950",
	"./pdf-privacy/Slothys Bakery Privacy Policy.pdf": "ac01",
	"./pdf-privacy/Slothys Cafe Privacy Policy.pdf": "8f7a",
	"./pdf-privacy/Slothys Pizza Master Privacy Policy.pdf": "5a30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";